"use strict";

const RoutineInspectionRouteFactory = require("./routineInspectionRouteFactory");

const CatchBasinRoutes = function () {
  const inspectionRoute = RoutineInspectionRouteFactory.createRoute({
    resourceKey: "routineMaintenanceInspection",
    assetType: "catchBasin",
  });

  const legacyRedirectRoute = RoutineInspectionRouteFactory.createLegacyRedirect({
    assetType: "catchBasin",
    dataView: "muni-catch-basin",
  });

  return { inspectionRoute, legacyRedirectRoute };
};

module.exports = CatchBasinRoutes();
